import { createFileRoute } from '@tanstack/react-router';
import { SocialCompletePage } from '@/features/auth/social-complete-page';

export const Route = createFileRoute('/auth/social')({
    validateSearch: (search: Record<string, unknown>): { next?: string } =>
        typeof search.next === 'string' ? { next: search.next } : {},
    component: function SocialRoute() {
        const { next } = Route.useSearch();
        return <SocialCompletePage next={next} />;
    },
});
